export const EXISTING_MAIL = "Already exists from custom middleware"
export const EXISTING_FACTORY_NUMBER = "Already exists from custom middleware"
export const EXISTING_PIB = "Već postoji klijent sa unetim matičnim brojem"